import React, { useEffect, useState } from "react"
import Page from "../Page/Page"
import { Box, Button, Container, Grid, Typography } from "@mui/material"
import Cookies from "js-cookie"
import { useLocation, useNavigate } from "react-router-dom"
import Axios from "../../Util/Axios"
import { useParams } from "react-router"
import CustomOrderOptionSelect from "./CustomOrderOptionSelect"
import DimensionSlider from "./DimensionSlider"
import CustomOrderTextField from "./CustomOrderTextField"
import AddColorModal from "./AddColorModal"
import Shape from "./Shape/Shape."
import Blank from "./Blank/Blank"
import Logo from "./Logo/Logo"
import Colors from "./Colors/Colors"
import Extras from "./Extras/Extras"
import FiberGlass from "./FiberGlass/FiberGlass"
import CustomOrderComment from "./CustomOrderComment/CustomOrderComment"
import { getSurfboardVolume } from "./CustomOrderUtil"
import CustomOrderBanner from "./CustomOrderBanner"
import Invoice from "./Invoice"
import { useDispatch } from "react-redux"
import { updateToastData } from "../../slices/toastSlice"
import { TOAST_SEVERITY_ERROR } from "../../components/core/Toast/Toast"
import CustomOrderAdditionalCharges from "./CustomOrderAdditionalCharges"
import ReactPixel from "react-facebook-pixel"
import CustomOrderSurfboards from "./BoardSvgs/CustomOrderSurfboards"
import CustomOrderButton from "./CustomOrderButton"

function sineWavePath(W, H, amp, phase, cycles, centerY) {
  const cy = centerY != null ? centerY : H / 2;
  const pts = [];
  for (let x = 0; x <= W; x += 3) {
    const t = (x / W) * cycles * 2 * Math.PI;
    const ampVar = 1 + 0.35 * Math.sin(t * 0.37 + phase * 1.7) + 0.2 * Math.sin(t * 0.71 + phase * 0.9) + 0.1 * Math.sin(t * 1.53 + phase * 2.3);
    const y = cy + amp * ampVar * Math.sin(phase + t);
    pts.push((x === 0 ? "M" : "L") + x + "," + y.toFixed(1));
  }
  return pts.join(" ");
}

const CustomOrder = ({ isStaff, presetEditor }) => {
  const navigate = useNavigate()
  const params = useParams()
  let location = useLocation()
  const customerFacingId = params.customer_facing_id
  const editingPresetId = params.editing_preset_id
  // const id = params.id

  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [presetName, setPresetName] = useState("")
  const [presetComment, setPresetComment] = useState(null)

  const [orderData, setOrderData] = useState(null)

  const [addColorModalActive, setAddColorModalActive] = useState(false)

  const [selectedLogoOption, setSelectedLogoOption] = useState(null)
  const [logoOptions, setLogoOptions] = useState([])

  const [abstractColorOption, setAbstractColorOption] = useState(null)
  const [selectedAbstractColorOption, setSelectedAbstractColorOption] =
    useState(null)

  const [selectedBottomColorOption, setSelectedBottomColorOption] =
    useState(null)
  const [bottomColorOptions, setBottomColorOptions] = useState([])

  const [selectedDeckColorOption, setSelectedDeckColorOption] = useState(null)
  const [deckColorOptions, setDeckColorOptions] = useState([])

  // const [selectedMidBandColorOption, setSelectedMidBandColorOption] =
  //   useState(null)
  // const [midBandColorOptions, setMidBandColorOptions] = useState([])
  //
  // const [selectedTailDipColorOption, setSelectedTailDipColorOption] =
  //   useState(null)
  //
  // const [tailDipColorOptions, setTailDipColorOptions] = useState([])
  // console.log(tailDipColorOptions)

  const [selectedPinLineColorOption, setSelectedPinLineColorOption] =
    useState(null)
  const [pinLineColorOptions, setPinLineColorOptions] = useState([])
  const [selectedFinBoxColorOption, setSelectedFinBoxColorOption] =
    useState(null)
  const [finBoxColorOptions, setFinBoxColorOptions] = useState([])

  const [selectedFinSetupOption, setSelectedFinSetupOption] = useState(null)
  const [finSetupOptions, setFinSetupOptions] = useState([])

  const [selectedNoseShapeOption, setSelectedNoseShapeOption] = useState(null)
  const [noseShapeOptions, setNoseShapeOptions] = useState([])

  const [selectedTailShapeOption, setSelectedTailShapeOption] = useState(null)
  const [tailShapeOptions, setTailShapeOptions] = useState([])

  const [selectedRockerOption, setSelectedRockerOption] = useState(null)
  const [rockerOptions, setRockerOptions] = useState([])

  const [selectedStringerTypeOption, setSelectedStringerTypeOption] =
    useState(null)
  const [stringerTypeOptions, setStringerTypeOptions] = useState([])

  const [selectedDeckPatchOption, setSelectedDeckPatchOption] = useState(null)
  const [deckPatchOptions, setDeckPatchOptions] = useState([])

  const [selectedTailPatchOption, setSelectedTailPatchOption] = useState(null)
  const [tailPatchOptions, setTailPatchOptions] = useState([])

  const [selectedFinishOption, setSelectedFinishOption] = useState(null)
  const [finishOptions, setFinishOptions] = useState([])

  const [selectedNumberOfStringersOption, setSelectedNumberOfStringersOption] =
    useState(null)
  const [numberOfStringersOptions, setNumberOfStringersOptions] = useState([])

  const [selectedFoamDensityOption, setSelectedFoamDensityOption] =
    useState(null)
  const [foamDensityOptions, setFoamDensityOptions] = useState([])

  const [selectedLengthOption, setSelectedLengthOption] = useState(null)
  const [lengthOptions, setLengthOptions] = useState([])

  const [selectedWidthOption, setSelectedWidthOption] = useState(null)
  const [widthOptionsSmall, setWidthOptionsSmall] = useState([])
  const [widthOptionsLarge, setWidthOptionsLarge] = useState([])

  const [selectedThicknessOption, setSelectedThicknessOption] = useState(null)
  const [thicknessOptionsSmall, setThicknessOptionsSmall] = useState([])
  const [thicknessOptionsLarge, setThicknessOptionsLarge] = useState([])

  const [selectedGlassOnFinOption, setSelectedGlassOnFinOption] = useState(null)
  const [glassOnFinsOption, setGlassOnFinsOption] = useState(null)

  const [selectedGlossFinishOption, setSelectedGlossFinishOption] =
    useState(null)
  const [glossFinishOption, setGlossFinishOption] = useState(null)

  const [presetId, setPresetId] = useState(null)

  const [presetTypeOptions, setPresetTypeOptions] = useState([
    {
      type: "display",
      value: "Display",
    },
    {
      type: "inventory",
      value: "Inventory",
    },
  ])
  const [selectedPresetType, setSelectedPresetType] = useState(null)

  const [loading, setLoading] = useState(true)
  const [wavePhase, setWavePhase] = useState(0)
  const [fromBoardViewer] = useState(() => new URLSearchParams(window.location.search).has("noseShape"))

  const [colorsOpen, setColorsOpen] = useState(true)
  const [requiresApproval, setRequiresApproval] = useState(true)
  // const [presetOptions, setPresetOptions] = useState([])

  let surfboardVolume = getSurfboardVolume(
    selectedLengthOption?.extra_data?.total_inches,
    selectedWidthOption?.extra_data?.total_inches,
    selectedThicknessOption?.extra_data?.total_inches,
    selectedLengthOption?.extra_data?.type
  )

  const getIsMobile = () =>
    window.matchMedia && window.matchMedia("(max-width: 480px)").matches
  const isMobile = getIsMobile()

  const dispatch = useDispatch()
  const setSelectedOptions = (options) => {
    setSelectedWidthOption(null)
    setSelectedAbstractColorOption(null)
    setSelectedLengthOption(null)
    setSelectedFinSetupOption(null)
    setSelectedNoseShapeOption(null)
    setSelectedTailShapeOption(null)
    setSelectedRockerOption(null)
    setSelectedStringerTypeOption(null)
    setSelectedDeckPatchOption(null)
    setSelectedTailPatchOption(null)
    setSelectedFinishOption(null)
    setSelectedNumberOfStringersOption(null)
    setSelectedFoamDensityOption(null)
    setSelectedGlassOnFinOption(null)
    setSelectedGlossFinishOption(null)
    setSelectedLogoOption(null)
    setSelectedBottomColorOption(null)
    setSelectedDeckColorOption(null)
    setSelectedFinBoxColorOption(null)
    setSelectedAbstractColorOption(null)
    setSelectedPinLineColorOption(null)
    // setSelectedTailDipColorOption(null)
    setSelectedFinishOption(null)
    // setSelectedMidBandColorOption(null)

    for (let option of options) {
      if (option.type === "width_small" || option.type === "width_large") {
        setSelectedWidthOption(option)
      }

      if (
        option.type === "thickness_small" ||
        option.type === "thickness_large"
      ) {
        setSelectedThicknessOption(option)
      }

      if (option.type === "logo") {
        setSelectedLogoOption(option)
      }
      if (option.type === "abstract_color") {
        setSelectedAbstractColorOption(option)
      }
      if (option.type === "length") {
        setSelectedLengthOption(option)
      }
      if (option.type === "fin_setup") {
        setSelectedFinSetupOption(option)
      }
      if (option.type === "nose_shape") {
        setSelectedNoseShapeOption(option)
      }
      if (option.type === "tail_shape") {
        setSelectedTailShapeOption(option)
      }
      if (option.type === "rocker") {
        setSelectedRockerOption(option)
      }
      if (option.type === "stringer_type") {
        setSelectedStringerTypeOption(option)
      }
      if (option.type === "deck_patch") {
        setSelectedDeckPatchOption(option)
      }
      if (option.type === "tail_patch") {
        setSelectedTailPatchOption(option)
      }
      if (option.type === "finish") {
        setSelectedFinishOption(option)
      }
      if (option.type === "number_of_stringers") {
        setSelectedNumberOfStringersOption(option)
      }
      if (option.type === "foam_density") {
        setSelectedFoamDensityOption(option)
      }
      if (option.type === "fin_box_color") {
        setSelectedFinBoxColorOption(option)
      }
      if (option.type === "glass_on_fins") {
        setSelectedGlassOnFinOption(option)
      }
      if (option.type === "gloss_finish") {
        setSelectedGlossFinishOption(option)
      }
      if (option.type === "pin_line_color") {
        setSelectedPinLineColorOption(option)
      }
      if (option.type === "deck_color") {
        setSelectedDeckColorOption(option)
      }
      if (option.type === "bottom_color") {
        setSelectedBottomColorOption(option)
      }
    }
  }

  const updateOptions = (newOptions, optionsToDelete) => {
    if (loading) {
      return
    }

    let selectedOptions = [
      selectedAbstractColorOption,
      selectedBottomColorOption,
      selectedDeckColorOption,
      selectedPinLineColorOption,
      selectedFinBoxColorOption,
      selectedFinSetupOption,
      selectedNoseShapeOption,
      selectedTailShapeOption,
      selectedRockerOption,
      selectedStringerTypeOption,
      selectedDeckPatchOption,
      selectedTailPatchOption,
      selectedFinishOption,
      selectedNumberOfStringersOption,
      selectedFoamDensityOption,
      selectedLengthOption,
      selectedWidthOption,
      selectedThicknessOption,
      selectedLogoOption,
      selectedPresetType,
      selectedGlassOnFinOption,
      selectedGlossFinishOption,
    ]
    selectedOptions = selectedOptions.filter((option) => option !== null)

    if (newOptions) {
      selectedOptions = selectedOptions.map((option) => {
        // Find a new option with the same id
        const newOption = newOptions.find(
          (newOption) => newOption?.type === option?.type
        )
        // If a new option was found, return it; otherwise, return the original option
        return newOption ? newOption : option
      })

      // Add new options not present in selectedOptions
      for (let newOption of newOptions) {
        if (!selectedOptions.find((option) => option?.id === newOption?.id)) {
          selectedOptions.push(newOption)
        }
      }
    }

    if (optionsToDelete) {
      selectedOptions = selectedOptions.filter((option) => {
        return !optionsToDelete.find((x) => {
          return x?.id === option.id
        })
      })
    }
    selectedOptions = selectedOptions.map((option) => {
      return option.id
    })

    if (selectedOptions.length > 0) {
      let data = {
        options: selectedOptions,
        name: name,
        phone: phone,
        email: email,
        preset_name: presetName,
        preset_id: presetId,
      }

      if (presetEditor) {
        Axios.post(
          `/api/staff-preset-detail/${editingPresetId}/action_update_options/`,
          data,
          navigate
        )
          .then(({ data }) => {
            setRequiresApproval(data.requires_approval)
            setSelectedOptions(data.options)
          })
          .catch((e) => {
            dispatch(
              updateToastData({
                message: "Error updating options. Please try again.",
                severity: TOAST_SEVERITY_ERROR,
              })
            )
          })
        return
      }

      if (!isStaff) {
        if (!customerFacingId) {
          Axios.post(`/api/order-detail/`, data, navigate)
            .then(({ data }) => {
              const queryParameters = new URLSearchParams(
                window.location.search
              )

              const preset_id = queryParameters.get("preset_id")

              if (preset_id) {
                setPresetId(preset_id)
                Cookies.set(
                  `${preset_id}_customer_facing_id`,
                  data.customer_facing_id
                )
              }

              const scrollY = window.scrollY
              navigate(`/custom-surfboard-order/${data.customer_facing_id}/`, {
                replace: true,
              })
              requestAnimationFrame(() => window.scrollTo(0, scrollY))
              let orderData = data
              orderData.address.full_name = name
              orderData.address.phone = phone
              orderData.address.email = email

              setOrderData({
                ...orderData,
              })
              setSelectedOptions(data.options)
              // getAvailableOptions()
            })
            .catch((e) => {
              dispatch(
                updateToastData({
                  message: "Error creating order. Please try again.",
                  severity: TOAST_SEVERITY_ERROR,
                })
              )
              setLoading(false)
            })
        } else {
          Axios.post(
            `/api/order-detail/${customerFacingId}/action_update_options/`,
            data,
            navigate
          )
            .then(({ data }) => {
              setOrderData(data)
              setRequiresApproval(data.requires_approval)
              setSelectedOptions(data.options)
            })
            .catch((e) => {
              dispatch(
                updateToastData({
                  message: "Error updating options. Please try again.",
                  severity: TOAST_SEVERITY_ERROR,
                })
              )
            })
        }
      } else {
        Axios.post(
          `/api/staff-order-detail/${customerFacingId}/action_update_options/`,
          data,
          navigate
        )
          .then(({ data }) => {
            setOrderData(data)
            setRequiresApproval(data.requires_approval)
            setSelectedOptions(data.options)
          })
          .catch((e) => {
            dispatch(
              updateToastData({
                message: "Error updating options. Please try again.",
                severity: TOAST_SEVERITY_ERROR,
              })
            )
          })
      }
    }
  }

  const getData = () => {
    if (presetEditor) {
      Axios.get(`/api/staff-preset-detail/${editingPresetId}/`, navigate)
        .then(({ data }) => {
          // setPresetOptions(data.options)
          setSelectedOptions(data.options)
          setPresetName(data.name)
          setSelectedPresetType({
            type: data.type,
            value: data.type_display,
          })
          setPresetComment(data.comment)
          setLoading(false)
        })
        .catch((e) => {
          setLoading(false)
        })
      return
    }
    if (isStaff) {
      setLoading(true)
      Axios.get(`/api/staff-order-detail/${customerFacingId}/`, navigate)
        .then(({ data }) => {
          setOrderData(data)
          setName(data?.address?.full_name || "")
          setEmail(data?.address?.email || "")
          setPhone(data?.address?.phone || "")
          setRequiresApproval(data.requires_approval)
          setSelectedOptions(data.options)
          setLoading(false)
        })
        .catch((e) => {
          setLoading(false)
        })
      return
    }

    const queryParameters = new URLSearchParams(window.location.search)
    const preset_id = queryParameters.get("preset_id")

    if (preset_id) {
      setPresetId(preset_id)
      let existingId = Cookies.get(`${preset_id}_customer_facing_id`)

      if (existingId) {
        navigate(`/custom-surfboard-order/${existingId}/`, {
          replace: true,
        })
      } else {
        setLoading(true)

        Axios.get(`/api/preset-detail/${preset_id}/`, navigate)
          .then(({ data }) => {
            // setPresetOptions(data.options)
            setSelectedOptions(data.options)
            setName("")
            setPresetName(data.name)
            setPhone("")
            setEmail("")
            setLoading(false)
            // navigate(`/custom-surfboard-order/`, {
            //   replace: true,
            // })
          })
          .catch((e) => {
            setLoading(false)
          })
      }
    } else if (customerFacingId) {
      setLoading(true)
      Axios.get(`/api/order-detail/${customerFacingId}/`, navigate)
        .then(({ data }) => {
          setOrderData(data)
          setPresetName(data.preset_name)
          setName(data?.address?.full_name || "")
          setEmail(data?.address?.email || "")
          setPhone(data?.address?.phone || "")
          setRequiresApproval(data.requires_approval)
          setSelectedOptions(data.options)
          setLoading(false)
        })
        .catch((e) => {
          setLoading(false)
        })
    } else {
      Axios.get(`/api/preset-detail/?type=display`, navigate)
        .then(({ data }) => {
          const preset = data.results[0]
          setPresetId(preset.id)
          const options = preset.options.filter(
            (o) => o.type !== "deck_color" && o.type !== "bottom_color"
          )
          setSelectedOptions(options)
          setLoading(false)
        })
        .catch((e) => {
          setLoading(false)
        })
    }
  }
  const getAvailableOptions = () => {
    Axios.get("/api/site-configuration/1/get_options/", navigate).then(
      ({ data }) => {
        setAbstractColorOption(data.abstract_color[0])
        setBottomColorOptions(data.bottom_color)
        setDeckColorOptions(data.deck_color)
        setDeckPatchOptions(data.deck_patch)
        setFinBoxColorOptions(data.fin_box_color)
        setFinSetupOptions(data.fin_setup)
        setFinishOptions(data.finish)
        setFoamDensityOptions(data.foam_density)
        setGlassOnFinsOption(data.glass_on_fins[0])
        setGlossFinishOption(data.gloss_finish[0])
        setLengthOptions(data.length)
        setLogoOptions(data.logo)
        // setMidBandColorOptions(data.mid_band_color)
        setNoseShapeOptions(data.nose_shape)
        setNumberOfStringersOptions(data.number_of_stringers)
        setPinLineColorOptions(data.pin_line_color)
        setRockerOptions(data.rocker)

        setStringerTypeOptions(data.stringer_type)
        // setTailDipColorOptions(data.tail_dip_color)
        setTailPatchOptions(data.tail_patch)
        setTailShapeOptions(data.tail_shape)
        setThicknessOptionsLarge(data.thickness_large)
        setThicknessOptionsSmall(data.thickness_small)
        setWidthOptionsLarge(data.width_large)
        setWidthOptionsSmall(data.width_small)

        setLoading(false)
      }
    )
  }

  let allowedDeckColorOptions = []
  if (selectedBottomColorOption) {
    let whiteColorOption = deckColorOptions.find((x) => x.value === "#ffffff")
    let allowedColorOption = deckColorOptions.find(
      (x) => x.value === selectedBottomColorOption.value
    )
    if (whiteColorOption) {
      allowedDeckColorOptions.push(whiteColorOption)
      allowedDeckColorOptions.push(allowedColorOption)
    }
  }

  // Apply board viewer URL params to custom order selections
  // Apply board viewer params after options load and initial data settles
  const [viewerParamsApplied, setViewerParamsApplied] = useState(false)
  useEffect(() => {
    if (viewerParamsApplied || loading) return
    const p = new URLSearchParams(window.location.search)
    if (!p.has("noseShape")) { setViewerParamsApplied(true); return }
    // Wait for option lists to be loaded
    if (!bottomColorOptions.length || !noseShapeOptions.length || !finSetupOptions.length) return

    const find = (opts, val) => opts.find((o) => o.value === val)
    const isClear = (c) => c === "#F5F5F5" || c === "#ffffff"

    const newOptions = []
    if (p.get("bottomColor")) {
      const bc = p.get("bottomColor")
      const opt = isClear(bc) ? find(bottomColorOptions, "#ffffff") : find(bottomColorOptions, bc)
      if (opt) { setSelectedBottomColorOption(opt); newOptions.push(opt) }
    }
    if (p.get("deckColor") && deckColorOptions.length) {
      const dc = p.get("deckColor")
      const opt = isClear(dc) ? find(deckColorOptions, "#ffffff") : find(deckColorOptions, dc)
      if (opt) { setSelectedDeckColorOption(opt); newOptions.push(opt) }
    }
    if (p.get("noseShape")) {
      const opt = find(noseShapeOptions, p.get("noseShape"))
      if (opt) { setSelectedNoseShapeOption(opt); newOptions.push(opt) }
    }
    if (p.get("tailShape") && tailShapeOptions.length) {
      const opt = find(tailShapeOptions, p.get("tailShape"))
      if (opt) { setSelectedTailShapeOption(opt); newOptions.push(opt) }
    }
    if (p.get("finSetup")) {
      const opt = find(finSetupOptions, p.get("finSetup"))
      if (opt) { setSelectedFinSetupOption(opt); newOptions.push(opt) }
    }
    if (p.get("deckPatch") && deckPatchOptions.length) {
      const opt = find(deckPatchOptions, p.get("deckPatch"))
      if (opt) { setSelectedDeckPatchOption(opt); newOptions.push(opt) }
    }
    if (p.get("tailPatch") && tailPatchOptions.length) {
      const opt = find(tailPatchOptions, p.get("tailPatch"))
      if (opt) { setSelectedTailPatchOption(opt); newOptions.push(opt) }
    }
    if (p.get("finColor") && finBoxColorOptions.length) {
      const opt = find(finBoxColorOptions, p.get("finColor"))
      if (opt) { setSelectedFinBoxColorOption(opt); newOptions.push(opt) }
    }
    if (p.get("pinLineColor") && pinLineColorOptions.length) {
      const opt = find(pinLineColorOptions, p.get("pinLineColor"))
      if (opt) { setSelectedPinLineColorOption(opt); newOptions.push(opt) }
    }
    if (p.get("stringerColor") && stringerTypeOptions.length) {
      const opt = stringerTypeOptions.find((o) => o.extra_data?.hex_color === p.get("stringerColor"))
      if (opt) { setSelectedStringerTypeOption(opt); newOptions.push(opt) }
    }
    if (p.get("stringerCount") && numberOfStringersOptions.length) {
      const countMap = { "0": "None", "1": "Single", "2": "Double", "3": "Triple", "5": "Five" }
      const val = countMap[p.get("stringerCount")]
      if (val) {
        const opt = find(numberOfStringersOptions, val)
        if (opt) { setSelectedNumberOfStringersOption(opt); newOptions.push(opt) }
      }
    }

    // Persist to backend
    if (newOptions.length) updateOptions(newOptions)

    setViewerParamsApplied(true)
    window.history.replaceState({}, "", window.location.pathname)
  }, [loading, viewerParamsApplied, bottomColorOptions, deckColorOptions, noseShapeOptions, tailShapeOptions, finSetupOptions, deckPatchOptions, tailPatchOptions, finBoxColorOptions, pinLineColorOptions, stringerTypeOptions, numberOfStringersOptions])

  useEffect(() => {
    getData()
  }, [location])

  useEffect(() => {
    getAvailableOptions()

    let purchaseCookie = Cookies.get("purchase_data")
    if (purchaseCookie) {
      try {
        purchaseCookie = purchaseCookie
          .replace(/\\(.)/g, "$1")
          .replace(/054/g, ",")
        const data = JSON.parse(purchaseCookie)
        ReactPixel.track("Purchase", data)
        Cookies.remove("purchase_data")
      } catch (exception) {}
    }
  }, [])

  useEffect(() => {
    let raf;
    const tick = () => { setWavePhase(p => p + 0.025); raf = requestAnimationFrame(tick); };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [])

  let widthOptions = []
  let thicknessOptions = []

  if (selectedLengthOption?.extra_data.total_inches < 100) {
    widthOptions = widthOptionsSmall
    thicknessOptions = thicknessOptionsSmall
  } else {
    widthOptions = widthOptionsLarge
    thicknessOptions = thicknessOptionsLarge
  }

  let finSetupOptionsToUse = finSetupOptions
  let noseShapeOptionsToUse = noseShapeOptions
  let tailShapeOptionsToUse = tailShapeOptions
  if (
    selectedNoseShapeOption?.value === "Hybrid" &&
    selectedTailShapeOption?.value === "Swallow"
  ) {
    finSetupOptionsToUse = finSetupOptions.filter((x) => {
      return ["Twin", "Quad"].includes(x.value)
    })
  }

  // Edit here, also edit get_options_list_from_request
  if (
    selectedLengthOption?.extra_data.total_inches < 66 ||
    selectedLengthOption?.extra_data.total_inches > 96
  ) {
    noseShapeOptionsToUse = noseShapeOptionsToUse.filter(
      (x) => x.value !== "Performance"
    )
  }

  if (selectedNoseShapeOption?.value === "Round") {
    tailShapeOptionsToUse = tailShapeOptionsToUse.filter(
      (x) => x.value !== "Squash" && x.value !== "Swallow"
    )
  }

  return (
    <Page hideNavBar hideFooter>
      <Box sx={{ minHeight: "100vh", backgroundColor: "#0d1b2a", position: "relative", overflow: "hidden" }}>
        {/* Background sine waves */}
        <svg style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", pointerEvents: "none", zIndex: 0 }} viewBox="0 0 600 400" preserveAspectRatio="none">
          <defs>
            <linearGradient id="bgWave1" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#c8b99a" stopOpacity="0.06"/><stop offset="100%" stopColor="#c8b99a" stopOpacity="0"/></linearGradient>
            <linearGradient id="bgWave2" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#c8b99a" stopOpacity="0.04"/><stop offset="100%" stopColor="#c8b99a" stopOpacity="0"/></linearGradient>
          </defs>
          <path d={sineWavePath(600, 400, 20, -wavePhase * 0.5, 1.5, 320) + " L600,400 L0,400 Z"} fill="url(#bgWave1)"/>
          <path d={sineWavePath(600, 400, 15, -wavePhase * 0.3 + 1, 2, 350) + " L600,400 L0,400 Z"} fill="url(#bgWave2)"/>
          <path d={sineWavePath(600, 400, 20, -wavePhase * 0.5, 1.5, 320)} fill="none" stroke="#c8b99a" strokeWidth="0.8" opacity="0.15"/>
          <path d={sineWavePath(600, 400, 15, -wavePhase * 0.3 + 1, 2, 350)} fill="none" stroke="#c8b99a" strokeWidth="0.6" opacity="0.1"/>
        </svg>
        {/* ── Page Header ─────────────────────────────────────────────────── */}
        <Box
          sx={{
            background: "linear-gradient(180deg, #152737 0%, #0d1b2a 100%)",
            borderBottom: "1px solid rgba(200,185,154,0.15)",
            pt: { xs: 4, md: 4.5 },
            pb: { xs: 1, md: 1.5 },
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Animated sine wave */}
          <svg style={{ position: "absolute", bottom: 0, left: 0, width: "100%", height: isMobile ? "60%" : "100%", pointerEvents: "none" }} viewBox="0 0 600 60" preserveAspectRatio="none">
            <defs>
              <filter id="sineGlow"><feGaussianBlur stdDeviation="2" result="blur"/><feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
              <linearGradient id="sineFill" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#c8b99a" stopOpacity="0.15"/><stop offset="100%" stopColor="#c8b99a" stopOpacity="0"/></linearGradient>
            </defs>
            <path d={sineWavePath(600, 60, isMobile ? 5 : 8, -wavePhase * 0.7, 2.5, 45) + " L600,60 L0,60 Z"} fill="url(#sineFill)" stroke="none"/>
            <path d={sineWavePath(600, 60, isMobile ? 5 : 8, -wavePhase * 0.7, 2.5, 45)} fill="none" stroke="#c8b99a" strokeWidth="1.2" opacity="0.3" filter="url(#sineGlow)"/>
          </svg>
          <Typography
            sx={{ color: "#c8b99a", letterSpacing: "0.15em", display: "block", mb: 1, fontSize: { xs: "1.2rem", md: "1.5rem" }, fontFamily: "'Kenilla', 'Playfair Display', serif", position: "relative", textTransform: "uppercase" }}
          >
            {presetEditor ? `Preset #${editingPresetId}` : <span style={{ cursor: "pointer" }} onClick={() => navigate("/")}>Marlin Surfboards</span>}
          </Typography>
          <Typography variant="h2" sx={{ mb: presetName ? 1 : 0, color: "#f5f2ec", position: "relative", letterSpacing: "0.25em", fontSize: { xs: "2.5rem", md: "3.5rem" }, fontFamily: "'Josefin Sans', sans-serif", textTransform: "uppercase", fontWeight: 300 }}>
            {presetEditor ? "Edit Preset" : "Custom Order"}
          </Typography>
          {presetName && presetEditor && (
            <Typography variant="h4" align="center" sx={{ mt: 1, color: "#e8e4dc", position: "relative" }}>
              {presetName}
            </Typography>
          )}
        </Box>

        <Container maxWidth={"xl"} sx={{ pb: 8 }}>
          <Box
            pt={4}
            display="flex"
            alignItems="center"
            flexDirection="column"
            sx={{ position: "relative" }}
          >
            <Box pb={2}>
              <Button
                variant="text"
                sx={{
                  color: "#c8b99a",
                  fontFamily: "'Josefin Sans', sans-serif",
                  fontSize: "0.7rem",
                  letterSpacing: "0.2em",
                  textTransform: "uppercase",
                  "&:hover": { color: "#f5f2ec" },
                }}
                onClick={() => {
                  if (!presetEditor) {
                    setName("")
                    setEmail("")
                    setPhone("")
                    setOrderData(null)
                    const pid = presetId || orderData?.preset_id
                    if (pid) {
                      Cookies.remove(`${pid}_customer_facing_id`)
                    }
                    navigate(
                      pid
                        ? `/custom-surfboard-order?preset_id=${pid}`
                        : `/custom-surfboard-order`,
                      { replace: true }
                    )
                  } else {
                    Axios.post(
                      `/api/staff-preset-detail/action_create_new_preset/`
                    ).then(({ data }) => {
                      setPresetName(data.name)
                      setSelectedPresetType({
                        type: data.type,
                        value: data.type_display,
                      })
                      setSelectedOptions(data.options)
                      navigate(
                        `/custom-surfboard-order-staff-preset/${data.id}/`,
                        {
                          replace: true,
                        }
                      )
                    })
                  }
                }}
              >
                {!orderData?.status || orderData?.status === "draft"
                  ? "Start Over"
                  : "Create New"}
              </Button>
            </Box>
          </Box>

          <Box display="flex" justifyContent="center">
            <Grid
              container
              spacing={4}
              alignItems="flex-start"
              alignContent="flex-start"
              style={{ position: "relative" }}
            >
              {!isMobile && (
                <CustomOrderSurfboards
                  selectedLogoOption={selectedLogoOption}
                  selectedDeckPatchOption={selectedDeckPatchOption}
                  selectedDeckColorOption={selectedDeckColorOption}
                  selectedBottomColorOption={selectedBottomColorOption}
                  selectedTailPatchOption={selectedTailPatchOption}
                  selectedFinBoxColorOption={selectedFinBoxColorOption}
                  selectedFinSetupOption={selectedFinSetupOption}
                  selectedNoseShapeOption={selectedNoseShapeOption}
                  selectedTailShapeOption={selectedTailShapeOption}
                  selectedPinLineColorOption={selectedPinLineColorOption}
                  selectedLengthOption={selectedLengthOption}
                  selectedWidthOption={selectedWidthOption}
                  selectedStringerTypeOption={selectedStringerTypeOption}
                  selectedNumberOfStringersOption={
                    selectedNumberOfStringersOption
                  }
                  selectedGlossFinishOption={selectedGlossFinishOption}
                  initialView3D={fromBoardViewer}
                />
              )}
              <Grid
                item
                xs={12}
                md={5}
                sx={{
                  textAlign: "center",
                  "& .MuiTypography-h4": {
                    fontFamily: "'Playfair Display', Georgia, serif",
                    fontSize: "1.3rem",
                    fontWeight: 400,
                    color: "#f5f2ec",
                    letterSpacing: "0.02em",
                    borderBottom: "1px solid rgba(200,185,154,0.2)",
                    pb: 1,
                    mb: 2,
                  },
                  "& .MuiTypography-h5": {
                    fontFamily: "'Playfair Display', Georgia, serif",
                    fontSize: "1.1rem",
                    fontWeight: 400,
                    color: "#c8b99a",
                    letterSpacing: "0.02em",
                    mt: 3,
                    mb: 1,
                  },
                  "& .MuiTypography-caption": {
                    fontFamily: "'Josefin Sans', sans-serif",
                    color: "#a0b0c0",
                  },
                  "& .MuiFormLabel-root": {
                    color: "#a0b0c0",
                  },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "rgba(21,39,55,0.5)",
                    fontFamily: "'Josefin Sans', sans-serif",
                    "& fieldset": {
                      borderColor: "rgba(200,185,154,0.2)",
                    },
                    "&:hover fieldset": {
                      borderColor: "#c8b99a",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#c8b99a",
                    },
                  },
                  "& .MuiSelect-select": {
                    fontFamily: "'Josefin Sans', sans-serif",
                    color: "#f5f2ec",
                  },
                  "& .MuiInputBase-input": {
                    fontFamily: "'Josefin Sans', sans-serif",
                    color: "#f5f2ec",
                  },
                  "& .MuiFormHelperText-root": {
                    fontFamily: "'Josefin Sans', sans-serif",
                    color: "#b0c8d8",
                    textAlign: "center",
                  },
                  "& .MuiInputLabel-root": {
                    width: "100%",
                    textAlign: "center",
                    transformOrigin: "center top",
                  },
                  "& .MuiInputLabel-shrink": {
                    transformOrigin: "center top",
                  },
                }}
              >
                {presetEditor && (
                  <React.Fragment>
                    <CustomOrderTextField
                      orderData={orderData}
                      title={"Preset Name"}
                      text={presetName}
                      setText={setPresetName}
                      updateOptions={updateOptions}
                      isStaff={isStaff}
                    />

                    <CustomOrderOptionSelect
                      isStaff={isStaff}
                      orderData={orderData}
                      updateOptions={updateOptions}
                      title={"Preset Type"}
                      my={0}
                      option={selectedPresetType}
                      options={presetTypeOptions}
                      onChange={(event) => {
                        let newPresetType = event.target.value.toLowerCase()
                        Axios.patch(
                          `/api/staff-preset-detail/${editingPresetId}/`,
                          {
                            type: newPresetType,
                          }
                        ).then(({ data }) => {
                          setSelectedPresetType({
                            type: data.type,
                            value: data.type_display,
                          })
                        })
                      }}
                    />
                  </React.Fragment>
                )}

                <Box pb={1} pt={1}>
                  <Typography variant="h4">
                    Dimensions
                  </Typography>
                </Box>
                <DimensionSlider
                  isStaff={isStaff}
                  orderData={orderData}
                  updateOptions={updateOptions}
                  title={"Length"}
                  option={selectedLengthOption}
                  options={lengthOptions}
                  showPrice
                />
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <DimensionSlider
                      isStaff={isStaff}
                      orderData={orderData}
                      updateOptions={updateOptions}
                      title={"Width"}
                      option={selectedWidthOption}
                      options={widthOptions}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <DimensionSlider
                      isStaff={isStaff}
                      orderData={orderData}
                      updateOptions={updateOptions}
                      title={"Thickness"}
                      option={selectedThicknessOption}
                      options={thicknessOptions}
                    />
                  </Grid>
                </Grid>

                {surfboardVolume && (
                  <Box>
                    <Typography
                      variant="caption"
                      gutterBottom
                      align="center"
                      style={{
                        fontFamily: "'Josefin Sans', sans-serif",
                        color: "#7ea8be",
                      }}
                    >
                      Volume is approximately {surfboardVolume}L
                    </Typography>
                  </Box>
                )}
                <Shape
                  orderData={orderData}
                  isStaff={isStaff}
                  updateOptions={updateOptions}
                  selectedFinSetupOption={selectedFinSetupOption}
                  setSelectedFinSetupOption={setSelectedFinSetupOption}
                  finSetupOptions={finSetupOptionsToUse}
                  selectedNoseShapeOption={selectedNoseShapeOption}
                  setSelectedNoseShapeOption={setSelectedNoseShapeOption}
                  noseShapeOptions={noseShapeOptionsToUse}
                  selectedTailShapeOption={selectedTailShapeOption}
                  setSelectedTailShapeOption={setSelectedTailShapeOption}
                  tailShapeOptions={tailShapeOptionsToUse}
                  selectedRockerOption={selectedRockerOption}
                  setSelectedRockerOption={setSelectedRockerOption}
                  rockerOptions={rockerOptions}
                />

                <Blank
                  isStaff={isStaff}
                  orderData={orderData}
                  updateOptions={updateOptions}
                  selectedStringerTypeOption={selectedStringerTypeOption}
                  setSelectedStringerTypeOption={setSelectedStringerTypeOption}
                  stringerTypeOptions={stringerTypeOptions}
                  selectedNumberOfStringersOption={
                    selectedNumberOfStringersOption
                  }
                  setSelectedNumberOfStringersOption={
                    setSelectedNumberOfStringersOption
                  }
                  numberOfStringersOptions={numberOfStringersOptions}
                  selectedFoamDensityOption={selectedFoamDensityOption}
                  setSelectedFoamDensityOption={setSelectedFoamDensityOption}
                  foamDensityOptions={foamDensityOptions}
                />

                <FiberGlass
                  isStaff={isStaff}
                  orderData={orderData}
                  updateOptions={updateOptions}
                  setSelectedDeckPatchOption={setSelectedDeckPatchOption}
                  selectedDeckPatchOption={selectedDeckPatchOption}
                  deckPatchOptions={deckPatchOptions}
                  selectedTailPatchOption={selectedTailPatchOption}
                  setSelectedTailPatchOption={setSelectedTailPatchOption}
                  tailPatchOptions={tailPatchOptions}
                  noseShape={selectedNoseShapeOption?.value || "Performance"}
                />
                <Logo
                  isStaff={isStaff}
                  orderData={orderData}
                  updateOptions={updateOptions}
                  selectedLogoOption={selectedLogoOption}
                  setSelectedLogoOption={setSelectedLogoOption}
                  logoOptions={logoOptions}
                />
                <Box pt={4}>
                  <Colors
                    isStaff={isStaff}
                    orderData={orderData}
                    open={colorsOpen}
                    setOpen={setColorsOpen}
                    updateOptions={updateOptions}
                    selectedFinBoxColorOption={selectedFinBoxColorOption}
                    setSelectedFinBoxColorOption={setSelectedFinBoxColorOption}
                    setAddColorModalActive={setAddColorModalActive}
                    finBoxColorOptions={finBoxColorOptions}
                    selectedBottomColorOption={selectedBottomColorOption}
                    setSelectedBottomColorOption={setSelectedBottomColorOption}
                    bottomColorOptions={bottomColorOptions}
                    selectedDeckColorOption={selectedDeckColorOption}
                    setSelectedDeckColorOption={setSelectedDeckColorOption}
                    deckColorOptions={deckColorOptions}
                    allowedDeckColorOptions={allowedDeckColorOptions}
                  />
                </Box>
                <Box pt={3}>
                  <Extras
                    isStaff={isStaff}
                    orderData={orderData}
                    updateOptions={updateOptions}
                    selectedGlassOnFinOption={selectedGlassOnFinOption}
                    setSelectedGlassOnFinOption={setSelectedGlassOnFinOption}
                    glassOnFinsOption={glassOnFinsOption}
                    selectedGlossFinishOption={selectedGlossFinishOption}
                    setSelectedGlossFinishOption={setSelectedGlossFinishOption}
                    glossFinishOption={glossFinishOption}
                    selectedPinLineColorOption={selectedPinLineColorOption}
                    setSelectedPinLineColorOption={setSelectedPinLineColorOption}
                    pinLineColorOptions={pinLineColorOptions}
                    selectedAbstractColorOption={selectedAbstractColorOption}
                    setSelectedAbstractColorOption={setSelectedAbstractColorOption}
                    abstractColorOption={abstractColorOption}
                  />
                </Box>
                {/*{!isMobile && (*/}

                <CustomOrderAdditionalCharges orderData={orderData} />

                <CustomOrderBanner orderData={orderData} />

                {!presetEditor && (
                  <React.Fragment>
                    <Box mb={1} mt={2}>
                      <CustomOrderTextField
                        orderData={orderData}
                        title={"Name"}
                        text={name}
                        setText={setName}
                        updateOptions={updateOptions}
                        isStaff={isStaff}
                      />
                    </Box>

                    <Box mb={1}>
                      <CustomOrderTextField
                        orderData={orderData}
                        title={"Email"}
                        text={email}
                        setText={setEmail}
                        updateOptions={updateOptions}
                        isStaff={isStaff}
                      />
                    </Box>
                    <Box>
                      <CustomOrderTextField
                        orderData={orderData}
                        title={"Phone"}
                        text={phone}
                        setText={setPhone}
                        updateOptions={updateOptions}
                        isStaff={isStaff}
                      />
                    </Box>
                  </React.Fragment>
                )}

                <Box mt={2}>
                  <CustomOrderComment
                    orderData={orderData}
                    setOrderData={setOrderData}
                    isStaff={false}
                    senderEmail={email}
                    requiresApproval={requiresApproval}
                    setRequiresApproval={setRequiresApproval}
                    customerFacingId={customerFacingId}
                    presetEditor={presetEditor}
                    editingPresetId={editingPresetId}
                    presetComment={presetComment}
                    setPresetComment={setPresetComment}
                  />
                </Box>
                {orderData && (
                  <Box mb={5}>
                    <Invoice orderData={orderData} />
                  </Box>
                )}

                <Box mb={0} mt={0}>
                  <CustomOrderButton
                    isStaff={isStaff}
                    orderData={orderData}
                    setOrderData={setOrderData}
                    requiresApproval={requiresApproval}
                    customerFacingId={customerFacingId}
                    // email={email}
                  />
                </Box>

                {/*)}*/}
              </Grid>
              {isMobile && (
                <React.Fragment>
                  <CustomOrderSurfboards
                    selectedLogoOption={selectedLogoOption}
                    selectedDeckPatchOption={selectedDeckPatchOption}
                    selectedDeckColorOption={selectedDeckColorOption}
                    selectedBottomColorOption={selectedBottomColorOption}
                    selectedTailPatchOption={selectedTailPatchOption}
                    selectedFinBoxColorOption={selectedFinBoxColorOption}
                    selectedFinSetupOption={selectedFinSetupOption}
                    selectedNoseShapeOption={selectedNoseShapeOption}
                    selectedTailShapeOption={selectedTailShapeOption}
                    selectedPinLineColorOption={selectedPinLineColorOption}
                    selectedLengthOption={selectedLengthOption}
                    selectedWidthOption={selectedWidthOption}
                    selectedStringerTypeOption={selectedStringerTypeOption}
                    selectedNumberOfStringersOption={
                      selectedNumberOfStringersOption
                    }
                    selectedGlossFinishOption={selectedGlossFinishOption}
                    initialView3D={fromBoardViewer}
                  />
                </React.Fragment>
              )}
            </Grid>
          </Box>
        </Container>
      </Box>

      {/* Back to Home */}
      <Box sx={{ display: "flex", justifyContent: "center", py: 4, bgcolor: "#0d1b2a" }}>
        <a href="/" style={{ textDecoration: "none" }}>
          <Typography sx={{
            color: "#8a9bb0", fontFamily: "'Josefin Sans', sans-serif", fontSize: "0.6rem",
            textTransform: "uppercase", letterSpacing: "0.25em",
            transition: "color 0.2s ease", "&:hover": { color: "#c9a84c" },
          }}>
            Back to Home
          </Typography>
        </a>
      </Box>

      <AddColorModal
        orderData={orderData}
        colorsOpen={colorsOpen}
        setColorsOpen={setColorsOpen}
        active={addColorModalActive}
        setActive={setAddColorModalActive}
        selectedBottomColorOption={selectedBottomColorOption}
        setSelectedBottomColorOption={setSelectedBottomColorOption}
        bottomColorOptions={bottomColorOptions}
        deckColorOptions={deckColorOptions}
        selectedDeckColorOption={selectedDeckColorOption}
        setSelectedDeckColorOption={setSelectedDeckColorOption}
        selectedPinLineColorOption={selectedPinLineColorOption}
        setSelectedPinLineColorOption={setSelectedPinLineColorOption}
        pinLineColorOptions={pinLineColorOptions}
        selectedAbstractColorOption={selectedAbstractColorOption}
        setSelectedAbstractColorOption={setSelectedAbstractColorOption}
        abstractColorOption={abstractColorOption}
        updateOptions={updateOptions}
      />
    </Page>
  )
}

export default CustomOrder
